export const ListItemVariableNames = {
  BackgroundColor: '--list-item-background-color',
  HoverBackgroundColor: '--list-item-hover-background-color',
  FocusBorderColor: '--list-item-focus-border-color',
  FontSize: '--list-item-font-size',
  BorderSize: '--list-item-border-size',
  HorizontalPadding: '--list-item-horizontal-padding',
  Color: '--list-item-color',
  IconColor: '--list-item-icon-color',
  IconSize: '--list-item-icon-size',
  Gap: '--list-item-gap',
  Height: '--list-item-min-height',
} as const;
